if (process.env.NODE_ENV === 'development') {
    void import('react-scan').then(({ scan }) => {
        scan({ enabled: true });
    });
}

import 'antd/dist/antd.css';
import './index.scss';
import 'core-js/actual';
import 'dayjs/locale/pt-br';
import { TanStackDevtools } from '@tanstack/react-devtools';
import { hotkeysDevtoolsPlugin } from '@tanstack/react-hotkeys-devtools';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { createHead, UnheadProvider } from '@unhead/react/client';
import dayjs from 'dayjs';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@/state/store';
import { App } from './App/App';
import { sendReactError } from './error';
import { initBeforeReact } from './initBeforeReact';
import { queryClient } from './queryClient';
import { router } from './router/Router';

initBeforeReact();

dayjs.locale('pt-br');

const head = createHead();

const container = document.getElementById('root') as HTMLElement;

const root = createRoot(container, {
    onCaughtError: (error, errorInfo) => sendReactError('caught', error, errorInfo),
    onRecoverableError: (error, errorInfo) => sendReactError('recoverable', error, errorInfo),
    onUncaughtError: (error, errorInfo) => sendReactError('uncaught', error, errorInfo),
});

root.render(
    <StrictMode>
        <UnheadProvider head={head}>
            <Provider store={store}>
                <QueryClientProvider client={queryClient}>
                    <App />

                    <TanStackDevtools
                        plugins={[
                            {
                                defaultOpen: true,
                                name: 'TanStack Query',
                                render: <ReactQueryDevtoolsPanel />,
                            },
                            {
                                defaultOpen: false,
                                name: 'TanStack Router',
                                render: <TanStackRouterDevtoolsPanel router={router} />,
                            },
                            hotkeysDevtoolsPlugin(),
                        ]}
                    />
                </QueryClientProvider>
            </Provider>
        </UnheadProvider>
    </StrictMode>,
);
